import datapoints from 'owa-mail-list-store/lib/datapoints';
import { action } from 'satcheljs';
export { ReactListViewType, TableQueryType };
/**
 * Single select mail row action
 * @param tableView where the operation is being performed
 * @param rowKey the rowKey of the item to select
 * @param isUserNavigation whether user's click or action triggered this action
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export var singleSelectRow = action('SINGLE_SELECT_ROW', function (tableView, rowKey, isUserNavigation, mailListItemSelectionSource) {
    return {
        tableView: tableView,
        rowKey: rowKey,
        isUserNavigation: isUserNavigation,
        mailListItemSelectionSource: mailListItemSelectionSource,
        datapointConfig: {
            name: datapoints.SelectMailItemDatapoint.datapoint.name,
            options: datapoints.SelectMailItemDatapoint.datapoint.options,
            customData: datapoints.SelectMailItemDatapoint.datapoint.customData(tableView, rowKey, isUserNavigation, mailListItemSelectionSource),
        },
    };
});
/**
 * Toggle selection state on the given row
 * @param tableView where the selection took place
 * @param rowKey the rowKey of the item to toggle selection on
 * @param isUserNavigation whether user's click or action triggered this action
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export var toggleSelectRow = action('TOGGLE_SELECT_ROW', function (tableView, rowKey, isUserNavigation, mailListItemSelectionSource) {
    return {
        tableView: tableView,
        rowKey: rowKey,
        isUserNavigation: isUserNavigation,
        mailListItemSelectionSource: mailListItemSelectionSource,
    };
});
/**
 * After promise has returned following a selection change action
 * @param rowKey the rowKey of the item that selection changed on
 * @param tableView where the selection took place
 * @param mailListItemSelectionSource The source of selection on mail item
 * @param listViewType - list view type (e.g. conversation, item)
 */
export var onAfterSelectionChanged = action('ON_AFTER_SELECTION_CHANGED', function (rowKey, tableView, mailListItemSelectionSource, listViewType) { return ({
    rowKey: rowKey,
    tableView: tableView,
    mailListItemSelectionSource: mailListItemSelectionSource,
    listViewType: listViewType,
}); });
/**
 * Set selection state on the given row
 * @param rowKey the rowKey of the item to toggle selection on
 * @param tableViewId of the table where the selection took place
 * @param shouldSelect - whether the row should be selected or deselected
 */
export var setSelectionOnRow = action('SET_SELECTION_ON_ROW', function (rowKey, tableViewId, shouldSelect) {
    return {
        rowKey: rowKey,
        tableViewId: tableViewId,
        shouldSelect: shouldSelect,
    };
});
/**
 * Reset the list view expansion state (expanded conversation)
 */
export var resetListViewExpansionViewState = action('RESET_LIST_VIEW_EXPANSION_VIEW_STATE');
/**
 * Set the list view expansion loading state
 */
export var setListViewExpansionLoadingState = action('SET_LIST_VIEW_EXPANSION_LOADING_STATE', function (shouldBeExpanded) { return ({
    shouldBeExpanded: shouldBeExpanded,
}); });
/**
 * Called when an item part is clicked
 * @param nodeId the nodeId of the clicked item part
 * @param itemId the itemId of the clicked item part
 * @param tableView - where the selection took place
 */
export var itemPartClicked = action('ITEM_PART_CLICKED', function (nodeId, itemId, allNodeIds, tableView) { return ({
    nodeId: nodeId,
    itemId: itemId,
    allNodeIds: allNodeIds,
    tableView: tableView,
}); });
/**
 * Called when an item part is clicked
 * @param rowKey the rowKey for the parent conversation of the item part
 * @param tableView - where the delete took place
 */
export var selectFirstItemPart = action('SELECT_FIRST_ITEM_PART', function (rowKey, tableView) { return ({
    rowKey: rowKey,
    tableView: tableView,
}); });
/**
 * Called when an item part is clicked
 * @param rowKey the rowKey for the parent conversation of the item part
 * @param tableView - where the delete took place
 */
export var selectNextItemPart = action('SELECT_NEXT_ITEM_PART', function (rowKey, tableView) { return ({
    rowKey: rowKey,
    tableView: tableView,
}); });
/**
 * Called to open the context menu for an expanded item part
 * @param evt the event that caused the context menu to open
 * @param nodeId the Id of the item part that was selected
 * @param allNodeIds all the node Ids for the conversation
 */
export var onItemPartContextMenu = action('ON_ITEM_PART_CONTEXT_MENU', function (evt, nodeId, allNodeIds) { return ({
    evt: evt,
    nodeId: nodeId,
    allNodeIds: allNodeIds,
}); });
/**
 * Select a single expanded item part
 * @param rowKey the instance key of the conversation
 * @param nodeIdToSelect the nodeId of the item part to select
 * @param allNodeIds of the conversation
 */
export var singleSelectItemPart = action('SINGLE_SELECT_ITEM_PART', function (rowKey, nodeIdToSelect, allNodeIds) { return ({
    rowKey: rowKey,
    nodeIdToSelect: nodeIdToSelect,
    allNodeIds: allNodeIds,
}); });
/**
 * Toggle selection on an item part
 * @param nodeId the nodeId of the item part to toggle selection
 * @param allNodeIds of the conversation
 */
export var toggleSelectItemPart = action('TOGGLE_SELECT_ITEM_PART', function (nodeId, allNodeIds) { return ({
    nodeId: nodeId,
    allNodeIds: allNodeIds,
}); });
/**
 * Toggle between select all and clear selection on the table
 * @param tableView where the operation is being performed
 */
export var toggleSelectAllRows = action('TOGGLE_SELECT_ALL_ROWS', function (tableView) {
    return {
        tableView: tableView,
    };
});
/**
 * Perform range selection from current selection to target row key
 * @param tableView where the selection took place
 * @param targetRowKey the rowKey of the item to extend range selection to
 * @param mailListItemSelectionSource The source of selection on mail item
 * @param isCtrlKeyDown - whether the Control key is down for this operation
 */
export var rangeSelectRow = action('RANGE_SELECT_ROW', function (tableView, targetRowKey, mailListItemSelectionSource, isCtrlKeyDown) {
    return {
        tableView: tableView,
        targetRowKey: targetRowKey,
        mailListItemSelectionSource: mailListItemSelectionSource,
        isCtrlKeyDown: isCtrlKeyDown,
    };
});
/**
 * Resets selection in the given table
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export var resetSelection = action('RESET_SELECTION', function (tableView, mailListItemSelectionSource) {
    return {
        tableView: tableView,
        mailListItemSelectionSource: mailListItemSelectionSource,
    };
});
/**
 * Resets selection in the given table
 * @param tableView where the operation is being performed
 */
export var resetSelectionOnTable = action('RESET_SELECTION', function (tableView) {
    return {
        tableView: tableView,
    };
});
/**
 * Select the next row
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export var selectNextRow = action('SELECT_NEXT_ROW', function (tableView, mailListItemSelectionSource) {
    return {
        tableView: tableView,
        mailListItemSelectionSource: mailListItemSelectionSource,
        datapointConfig: {
            name: 'SelectNextMailRow',
            options: { isQos: true },
            customData: [
                mailListItemSelectionSource,
                tableView.tableQuery.listViewType,
                tableView.tableQuery.type,
                tableView.tableQuery.type === 1 /* Search */ &&
                    tableView.tableQuery.searchScope.kind,
            ],
        },
    };
});
/**
 * Select the previous row
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export var selectPreviousRow = action('SELECT_PREVIOUS_ROW', function (tableView, mailListItemSelectionSource) {
    return {
        tableView: tableView,
        mailListItemSelectionSource: mailListItemSelectionSource,
        datapointConfig: {
            name: 'SelectPreviousMailRow',
            options: { isQos: true },
            customData: [
                mailListItemSelectionSource,
                tableView.tableQuery.listViewType,
                tableView.tableQuery.type,
                tableView.tableQuery.type === 1 /* Search */ &&
                    tableView.tableQuery.searchScope.kind,
            ],
        },
    };
});
/**
 * Select the next row in multiselect mode
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 * @param isCtrlDown whether user is also holding down ctrl key
 */
export var multiSelectNextRow = action('MULTI_SELECT_NEXT_ROW', function (tableView, mailListItemSelectionSource, isCtrlDown) {
    return {
        tableView: tableView,
        mailListItemSelectionSource: mailListItemSelectionSource,
        isCtrlDown: isCtrlDown,
    };
});
/**
 * Select the previous row in multiselect mode
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 * @param isCtrlDown whether user is also holding down ctrl key
 */
export var multiSelectPreviousRow = action('MULTI_SELECT_PREVIOUS_ROW', function (tableView, mailListItemSelectionSource, isCtrlDown) {
    return {
        tableView: tableView,
        mailListItemSelectionSource: mailListItemSelectionSource,
        isCtrlDown: isCtrlDown,
    };
});
export var resetBusStopStateMap = action('RESET_BUS_STOP_STATE_MAP');
//# sourceMappingURL=mailListSelectionActions.js.map